import Joyride, { STATUS } from 'react-joyride';
import React from 'react';
import './CreateDesignOnboarding.css';

const CreateDesignOnboarding = ({run, setRunDefault}) => {

  const handleJoyrideCallback = (data) => {
    //reset state in parent component
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED, STATUS.WAITING];
    if (finishedStatuses.includes(status) || data?.action === 'close') {
      setRunDefault(true)
    }
  }

  const steps = [
    {
      target: '.group-elements',
      placement: window.innerWidth < 1100 ? 'top' : 'right',
      content: <p className='step-1-content'>Navigate through the sections of various objects to incorporate into your design.</p>,
      title: <p className='step-1-title'>Navigate Design Elements</p>,
      disableBeacon: true
    },
    {
      target: '.elements',
      content: <p className='step-2-content'>Browse through the different objects available to find elements you can use for your design.</p>,
      placement: window.innerWidth < 1100 ? 'top' : 'right',
      title: <p className='step-2-title'>Select Objects for Your Design</p>
    },
    {
      target: '.konvajs-content',
      content: <p className='step-3-content'>Choose an object, then place it where you want on the design. You can also rotate and resize it to fit your design perfectly.</p>,
      placement: window.innerWidth < 1100 ? 'bottom' : 'left',
      title: <p className='step-3-title'>Place Objects</p>,
    },
    {
      target: window.innerWidth < 1100 ? '.editor_func_mobile' : '.editor_func_desk',
      content: <p className='step-4-content'>Navigate to the edit menu to alter, delete, or exchange any of your elements, and publish your design when you’re done.</p>,
      placement: window.innerWidth < 1100 ? 'bottom' : 'top',
      title: <p className='step-4-title'>Edit and Publish Your Design</p>,
    }
  ]

    return (
        <React.Fragment>
            <Joyride
            steps={steps}
            run={run}
            continuous
            showSkipButton={true}
            showProgress
            totalSteps={steps.length}
            callback={handleJoyrideCallback}
            locale={{
              last: 'Close',
              next: 'Next',
              back: 'Back',
              skip: 'Skip',
              close: 'Close'
            }}
            styles={{
                tooltip: {
                    borderRadius: '20px'
                },
                spotlight: {
                  zIndex: 1000,
                  borderRadius: '20px'
                },
                buttonBack: {
                  backgroundColor: '#FFF',
                  color: '#06C067',
                  fontSize: window.innerWidth < 1100 ? '16px' : '22px',
                  fontWeight: window.innerWidth < 1100 ? '400' : '700',
                  border: 'none'
                },
                buttonNext: {
                  backgroundColor: '#06C067',
                  fontSize: window.innerWidth < 1100 ? '16px' : '22px',
                  fontWeight: window.innerWidth < 1100 ? '400' : '700',
                  padding: window.innerWidth < 480 ? '12px 16px' : '14px 40px',
                  color: '#FFF',
                  borderRadius: '100px',
                  border: 'none',
                },
                buttonSkip: {
                  color: '#000',
                  fontSize: '20px',
                  fontWeight: '700',
                  backgroundColor: '#FFF',
                  border: 'none'
                }
            }}
            />
      </React.Fragment>
    )
}

const buttonBackMobile = {

}

const buttonBackDesk = {
  
}

const buttonSkipMobile = {

}

const buttonSkipDesk = {

}

const buttonNextMobile = {

}

const buttonNextDesk = {

}

export default CreateDesignOnboarding;